export var BulkEditCampaignsSubject;
(function (BulkEditCampaignsSubject) {
    BulkEditCampaignsSubject["TAL"] = "edit_tal";
    BulkEditCampaignsSubject["Keywords"] = "edit_keywords";
    BulkEditCampaignsSubject["Topics"] = "edit_topics";
    BulkEditCampaignsSubject["Unspecified"] = "unspecified";
})(BulkEditCampaignsSubject || (BulkEditCampaignsSubject = {}));
export var BulkEditCampaignOperation;
(function (BulkEditCampaignOperation) {
    BulkEditCampaignOperation["Replace"] = "replace";
    BulkEditCampaignOperation["Merge"] = "merge";
})(BulkEditCampaignOperation || (BulkEditCampaignOperation = {}));
//# sourceMappingURL=BulkEditCampaigns.js.map